/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_CarryInputs */

const en_us2_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carry`)
};

const pt_br2_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carregamento`)
};

const es_419_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`acarreo`)
};

const pt_pt2_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`transporte de carga`)
};

const fr_fr2_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`porté`)
};

const de_de2_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tragen`)
};

const it_it2_catalog_movement_carry = /** @type {(inputs: Catalog_Movement_CarryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trasporto`)
};

/**
* | output |
* | --- |
* | "carry" |
*
* @param {Catalog_Movement_CarryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_carry = /** @type {((inputs?: Catalog_Movement_CarryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_CarryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_carry(inputs)
	if (locale === "es-419") return es_419_catalog_movement_carry(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_carry(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_carry(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_carry(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_carry(inputs)
	return en_us2_catalog_movement_carry(inputs)
});
export { catalog_movement_carry as "catalog.movement.carry" }